import { authProtectedRoutes, publicRoutes } from "./AllRoutes";

const Index =  publicRoutes.concat(authProtectedRoutes)

export default Index;